module.exports = __webpack_public_path__ + "static/etecube-e4b6f0b5fa7a29a4e7b99de1af6e7adc.png";